import { ChatDetails } from './models/chat-details';
import { ChatId } from './models/chat-id';
import { ChatMessage } from './models/chat-message';

export class OpenChat {
   public static readonly type = '[Chat] Open Chat';

   constructor(public id: ChatId) {}
}

export class CloseChat {
   public static readonly type = '[Chat] Close Chat';

   constructor(public id: ChatId) {}
}

export class RemoveChat {
   public static readonly type = '[Chat] Remove Chat';

   constructor(public id: ChatId) {}
}

export class StartReQueueChat {
   public static readonly type = '[Chat] Start ReQueue Chat';

   constructor(public id: ChatId) {}
}

export class StartLoadingChatDetails {
   public static readonly type = '[Chat] Start Loading Chat Details';

   constructor(public id: ChatId, public openChat: boolean) {}
}

export class GetChatDetailsById {
   public static readonly type = '[Chat] Get Chat Details By Id';

   constructor(public id: ChatId) {}
}

export class StartLoadingChatDetailsByUid {
   public static readonly type = '[Chat] Start Loading Chat Details by uid';

   constructor(public id: ChatId, public openChat: boolean) {}
}

export class GetChatDetailsByUid {
   public static readonly type = '[Chat] Get Chat Details By Uid';

   constructor(public id: ChatId, public openChat: boolean) {}
}

export class ChatDetailsLoaded {
   public static readonly type = '[Chat] Chat Details Loaded';

   constructor(public id: ChatId, public chatDetails: ChatDetails) {}
}

export class ChatDetailsByUidLoaded {
   public static readonly type = '[Chat] Chat Details Loaded by uid';

   constructor(public id: ChatId, public chatDetails: ChatDetails, public openChat: boolean) {}
}

export class UpdateLastMessage {
   public static readonly type = '[Chat] Update Last Message';

   constructor(public id: ChatId, public lastMessage: ChatMessage) {}
}

export class IncrementNumberOfUnreadMessages {
   public static readonly type = '[Chat] Increment Number of Unread Messages';

   constructor(public id: ChatId) {}
}

export class ResetNumberOfUnreadMessages {
   public static readonly type = '[Chat] Reset Number of Unread Messages';

   constructor(public id: ChatId) {}
}

export class CheckStartLoadingChatToken {
   public static readonly type = '[Chat] Check Start Loading Chat Token';

   constructor() {}
}

export class StartLoadingChatToken {
   public static readonly type = '[Chat] Start Loading Chat Token';

   constructor() {}
}

export class ChatTokenLoaded {
   public static readonly type = '[Chat] Chat Token Loaded';

   constructor(public token: string) {}
}

export class MarkChatAsClosedByPeer {
   public static readonly type = '[Chat] Mark Chat as Closed By Peer';

   constructor(public id: ChatId) {}
}

export class NewChatGuestStatus {
   public static readonly type = '[Chat] New Guest Status';

   constructor(public id: ChatId, public status: string) {}
}

export class LoadChatGuestStatus {
   public static readonly type = '[Chat] Load Guest Status';

   constructor(public id: ChatId) {}
}
